export enum WizardStepKey {
  SelectFiles = 'select-files',
  ReviewExams = 'review-exams',
  UploadExams = 'upload-exams',
}
